/* eslint-disable */
// @ts-nocheck
import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import { fetchLinkCreationBlockedStatus } from './FraudFighterActions';

const V1 = '/v1';
const STATUS_PATH = '/status';

const FetchAppStatus = new ReduxAsyncAction('FETCH_APP_STATUS');
FetchAppStatus.registerRequest(async () => {
  const URI = `${V1}${STATUS_PATH}`;
  try {
    const appStatus = await dash_api.get(URI);
    return appStatus;
  } catch (e) {
    throw e;
  }
});

export const FETCH_APP_STATUS = FetchAppStatus.constants;
export const fetchAppStatus = FetchAppStatus.request;

const UpdateCreditCardStatus = new ReduxAsyncAction('UPDATE_CREDIT_CARD_STATUS');
UpdateCreditCardStatus.registerRequest(async () => {
  const URI = `${V1}${STATUS_PATH}/set-valid-card`;
  const response = await dash_api.post(URI, {});
  return response;
});

export const UPDATE_CREDIT_CARD_STATUS = UpdateCreditCardStatus.constants;
export const updateCreditCardStatus = () => async (dispatch) => {
  await dispatch(UpdateCreditCardStatus.request());
  setTimeout(() => {
    dispatch(fetchAppStatus());
    dispatch(fetchLinkCreationBlockedStatus());
  }, 500);
};

export const UPDATE_USER_HAS_CLOSED_TRIAL_BANNER = 'UPDATE_USER_HAS_CLOSED_TRIAL_BANNER';
export const updateUserHasClosedTrialBanner = () => {
  return {
    type: UPDATE_USER_HAS_CLOSED_TRIAL_BANNER,
    userHasClosedTrialBanner: true,
  };
};

export const UPDATE_USER_HAS_CLOSED_USAGE_BANNER = 'UPDATE_USER_HAS_CLOSED_USAGE_BANNER';
export const updateUserHasClosedUsageBanner = () => {
  return {
    type: UPDATE_USER_HAS_CLOSED_USAGE_BANNER,
    userHasClosedUsageBanner: true,
  };
};

export const UPDATE_USER_HAS_REQUESTED_PLATFORM_UPGRADE = 'UPDATE_USER_HAS_REQUESTED_PLATFORM_UPGRADE';
export const updateUserHasRequestedPlatformUpgrade = () => {
  return {
    type: UPDATE_USER_HAS_REQUESTED_PLATFORM_UPGRADE,
    userHasRequestedPlatformUpgrade: true,
  };
};

export default {
  fetchAppStatus,
  updateCreditCardStatus,
  updateUserHasClosedTrialBanner,
  updateUserHasClosedUsageBanner,
  updateUserHasRequestedPlatformUpgrade,
};
